import type { ConfigData } from '@plone/volto/types';

const applySettingsConfig = (config: ConfigData): ConfigData => {
  if (config.settings.navItems) {
    config.settings.navItems.push({
      title: 'My Subscriptions',
      url: '/personal-information',
      icon: 'user',
    });
  }

  // Add any other settings here
  
  return config;
};

export default applySettingsConfig;

